export default "__VITE_ASSET__BcppC71V__"